import { ErrorHandler, NgModule } from '@angular/core';

import { BrowserModule } from '@angular/platform-browser';
import { HttpClientModule } from '@angular/common/http';
import { AppRoutingModule } from './app-routing.module';

import { BrowserAnimationsModule } from '@angular/platform-browser/animations';

import { MaterialModule } from './shared/modules';

import { PropertyRecordService, AuthenticationService, GlobalErrorHandlerService } from './shared/services';

import { AppComponent } from './app.component';
import { AuthenticationGuard, ValidateParamsGuard } from './shared/guards';
import { SharedModule } from './shared';

import { httpInterceptorProviders } from './shared/interceptors';

import { InstanceService } from './modules/instance/services/instance.service';
import { ZoningCodeService } from './modules/instance/services/zoning-code.service';
import { ZoningCodeVersionService } from './modules/instance/services/zoning-code-version.service';
import { TaskService, ProcessService } from './modules/instance/services';
import { InstanceMonitoringService } from './modules/instance/services/instance-monitoring.service';
import { CookieService } from 'ngx-cookie-service';
import { SynchronizationModule } from './modules/synchronization/synchronization.module';
import { InstanceModule } from './modules/instance/instance.module';
import { ProcessCalculationStatisticService } from './modules/instance/services/process-calculation-statistic.service';
import { TaskItemService } from './modules/instance/services/task-item.service';
import { SchedulerModule } from './modules/scheduler/scheduler.module';
import { ConsoleModule } from './modules/console/console.module';

@NgModule({
    declarations: [AppComponent],
    imports: [
        BrowserAnimationsModule,
        BrowserModule,
        AppRoutingModule,
        HttpClientModule,
        MaterialModule,
        SharedModule,
        SynchronizationModule,
        InstanceModule,
        SchedulerModule,
        ConsoleModule
    ],
    providers: [
        GlobalErrorHandlerService,
        { provide: ErrorHandler, useClass: GlobalErrorHandlerService },
        InstanceService,
        ZoningCodeService,
        ZoningCodeVersionService,
        TaskService,
        PropertyRecordService,
        AuthenticationService,
        CookieService,
        httpInterceptorProviders,
        ValidateParamsGuard,
        AuthenticationGuard,
        ProcessService,
        InstanceMonitoringService,
        ProcessCalculationStatisticService,
        TaskItemService
    ],
    bootstrap: [AppComponent]
})
export class AppModule {}
